var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  test page\n  "),_c('audioWave',{attrs:{"PropsAudioUrl":_vm.PropsAudioUrl,"PropsBatchDate":_vm.PropsBatchDate,"PropsAudioName":_vm.PropsAudioName,"PropsHasLabeled":_vm.PropsHasLabeled,"PropsWantEmitEvent":_vm.PropsWantEmitEvent},on:{"feedbackDataToParent":_vm.getBackFromChild}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }